import { TransactionDetailDto } from "@admin_api/models/transaction-detail-dto";

export class TransactionSiblingsState {
    loading = false;
    error = null;
    record: Array<TransactionDetailDto> = [];
}
